/**
 * SendBot API Token Scopes
 */

export const API_TOKEN_SCOPES = {
  // SendBot core
  'orders:read': 'View orders and status',
  'orders:write': 'Create orders (send letters, wine, etc.)',
  'templates:read': 'View templates',
  'templates:write': 'Create and edit templates',
  'account:read': 'View account balance and transactions',
  'account:write': 'Top up account balance',

  // Profile & settings (from starter)
  'profile:read': 'Read your profile information',
  'profile:write': 'Update your profile',
  'settings:read': 'Read your preferences and settings',
  'settings:write': 'Update your preferences and settings',

  // Inherited from starter
  'activity:read': 'Read activity logs',
  'notifications:read': 'Read notifications',
  'notifications:write': 'Manage notifications',
  'chat:read': 'Read chat history',
  'chat:write': 'Send messages',
  'ai:use': 'Use AI features',

  // Admin
  'admin:read': 'Admin statistics and fulfilment queues',
  'admin:write': 'Update order status (fulfilment operators)',
} as const

export type ApiTokenScope = keyof typeof API_TOKEN_SCOPES
export const ALL_SCOPES = Object.keys(API_TOKEN_SCOPES) as ApiTokenScope[]

export const SCOPE_CATEGORIES = {
  'Orders & Templates': ['orders:read', 'orders:write', 'templates:read', 'templates:write'],
  'Account & Billing': ['account:read', 'account:write'],
  'Profile & Settings': ['profile:read', 'profile:write', 'settings:read', 'settings:write'],
  'Activity & Notifications': ['activity:read', 'notifications:read', 'notifications:write'],
  'AI & Chat': ['chat:read', 'chat:write', 'ai:use'],
  'Administration': ['admin:read', 'admin:write'],
} as const satisfies Record<string, readonly ApiTokenScope[]>

export function isValidScope(scope: string): scope is ApiTokenScope {
  return scope in API_TOKEN_SCOPES
}

export function validateScopes(scopes: string[]): { valid: boolean; invalid: string[] } {
  const invalid = scopes.filter((s) => !isValidScope(s))
  return { valid: invalid.length === 0, invalid }
}
